<template> 
  <div class="md-layout">
    <template v-for="(item, index) in media">
      <kab-card
        :key="index"
      >
        <template #card-image>
          <div
            class="boder-image-circle"
          >
            <img
              alt="kab logo"
              class="image-avatar"
              :src="require('@/assets/speaker-filled.png')"
            >
          </div>
        </template>
        <template #card-details>
          <div class="md-layout md-alignment-center-center audio-player"> 
            <vue-plyr>
              <audio
                controls
                playsinline
              >
                <source
                  :src="item.audio.url"
                  type="audio/mp3"
                >
              </audio>
            </vue-plyr>
          </div>
          <div class="md-layout md-alignment-center-center user-name"> 
            <h1> Artist </h1>
          </div>
          <div class="md-layout md-alignment-center-center user-name"> 
            <p> {{ item.audio.description }} </p>
          </div>
        </template>
      </kab-card>
    </template>
  </div>
</template>

<script>
import KabCard from '../KabCard'
export default {
  name: "StudioAudio",
  components: {
    KabCard
  },
  props: {
    project: {
      type: [Object, Array],
      default: () => []
    }
  },
  data() {
    return {
      videoId: '',
      showDialog: false,
      media: this.project
    }
  },
  watch: {
    project(value) {
      if (value.length > 0) {
        this.media = value
        return
      }
      this.media = []
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.video-preview {
  iframe {
    width: 100%; 
    height: 70vh;
  }
  margin-bottom: 30px;
}

.boder-image-circle {
  cursor: pointer;
  img {
    border: none !important;
  }
}
</style>
